import {
  brandPrimary70,
  darkModeTextColor,
  darkModeModalBackgroundColor,
  darkModeDarkTextColor,
  lightNeutral70,
  lightSurface1,
  lightTextBody,
  lightTextSubheading,
  darkNeutral10,
  darkModeTitleBackgroundColor,
  lightBlueActiveDarkMode,
  lightBlueActive,
  lighterBlueActive,
} from "constants/colors";
import { Z_INDEX } from "constants/constants";
import styled from "styled-components/macro";
import { CUSTOM_SCROLLBAR_CSS_HORIZONTAL } from "App/CUSTOM_SCROLLBAR_CSS";

export const DateAndShiftPickerStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rangeName {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: ${props => (props.$isDarkMode ? darkModeTextColor : "black")};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .range {
    color: ${props =>
      props.$isDarkMode ? darkModeDarkTextColor : lightTextSubheading};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;
  }
  .shiftButton {
    width: 148px;
    &.future {
      opacity: 0.5;
    }
  }
  .btn24Hours {
    width: 148px;
    flex-shrink: 0;
    .tooltipIndicator {
      position: absolute;
      top: -1px;
      right: 5px;
    }
  }
  .shiftButton,
  .btn24Hours {
    padding: 0 8px;
    height: 54px;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
  }
  .leftSide {
    .MuiButtonBase-root:hover {
      background: ${props =>
        props.$isDarkMode ? lightBlueActiveDarkMode : lightBlueActive};
    }
    ${CUSTOM_SCROLLBAR_CSS_HORIZONTAL}
    &::-webkit-scrollbar-thumb {
      border: 6px solid transparent;
      padding: 8px;
      margin-bottom: -4px;
    }
    margin-right: 8px;
    display: flex;
    align-items: center;
    .shiftButton:not(:last-child) {
      margin-right: 4px;
    }
    .MuiDivider-root {
      height: 16px;
      margin-right: 6px;
      margin-left: 2px;
      border-color: ${lightNeutral70};
    }
  }
  .rightSide {
    display: flex;
    align-items: center;
    .btnDatePickerContainer {
      white-space: nowrap;
      position: relative;
      .btnDatePickerText {
        position: absolute;
        color: ${props =>
          props.$isDarkMode ? darkModeDarkTextColor : lightTextSubheading};
        font-size: 9px;
      }
      .btnDatePicker {
        width: 280px;
        height: 48px;
        color: ${brandPrimary70};
        background: ${props =>
          props.$isDarkMode ? darkModeModalBackgroundColor : lightSurface1};
        &:hover {
          background: ${lighterBlueActive};
        }
        border: 1px solid ${brandPrimary70};
        font-weight: 400;
        font-family: "Open Sans";
        padding: 12px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .date {
          font-size: 16px;
          color: ${props =>
            props.$isDarkMode ? darkModeTextColor : lightTextBody};
          display: flex;
        }
        .offsetAndTimezoneIndicator {
          color: ${props =>
            props.$isDarkMode ? darkModeTextColor : lightTextBody};
          position: absolute;
          top: 1px;
          left: 6px;
          right: 0;
          font-size: 10px;
          height: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .MuiSvgIcon-root {
          color: ${props =>
            props.$isDarkMode ? darkModeTextColor : lightTextBody};
          width: 22px;
          height: 22px;
        }
      }

      .dateRangePickerContainer {
        position: absolute;
        top: 6px;
        right: 86px;
        z-index: ${Z_INDEX.L7};
        pointer-events: none;
        .datePickerButton {
          visibility: hidden;
        }
        .datePickerCalendar {
          visibility: visible;
          pointer-events: auto;
        }
      }
    }
  }

  button {
    padding: 12px 32px;
    border-radius: 4px;
    text-transform: none;
    font-weight: bold;
    background: ${props =>
      props.$isDarkMode ? darkModeTitleBackgroundColor : darkNeutral10};
    color: ${props => (props.$isDarkMode ? darkModeTextColor : "black")};
    &.active {
      border: 1px solid ${brandPrimary70};
      background: ${lightBlueActive};
    }
  }
  .btnForward,
  .btnBack {
    border-radius: 4px;
    width: 48px;
    height: 48px;
    padding: 0;
    &:hover {
      background: ${lightBlueActive};
    }
    .MuiSvgIcon-root {
      width: 28px;
      height: 28px;
      fill: ${brandPrimary70};
    }
  }
  .btnBack {
    margin-right: 6px;
  }

  .btnDatePickerText {
    top: 0;
  }
`;
